import axios, { AxiosInstance, InternalAxiosRequestConfig } from 'axios';

export class HttpClient {
    private readonly client: AxiosInstance;
    private readonly uploadClientInstance: AxiosInstance;

    constructor() {
        const baseURL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

        this.client = axios.create({
            baseURL,
            headers: {
                'Content-Type': 'application/json'
            }
        });

        this.uploadClientInstance = axios.create({
            baseURL
        });

        this.setupInterceptors();
    }

    private setupInterceptors() {
        this.client.interceptors.request.use(this.injectTokenInterceptor);
        this.uploadClientInstance.interceptors.request.use(this.injectTokenInterceptor);

        const responseInterceptorError = (error: any) => {
            if (error.response?.status === 401) {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                window.location.href = '/login';
            } else if (error.response?.status !== 404) {
                let errorMsg = error.response?.data?.detail || error.response?.data?.error || error.message || 'Error de conexión con el servidor.';
                if (typeof errorMsg === 'string' && errorMsg.toLowerCase().includes('network error')) {
                    errorMsg = 'Error en el servidor';
                }
                window.dispatchEvent(new CustomEvent('api-error', { detail: errorMsg }));
            }

            if (error.response?.data?.detail) {
                if (typeof error.response.data.detail !== 'string') {
                    error.response.data.error = JSON.stringify(error.response.data.detail);
                } else {
                    error.response.data.error = error.response.data.detail;
                }
            }
            return Promise.reject(error);
        };

        this.client.interceptors.response.use((response) => response, responseInterceptorError);
        this.uploadClientInstance.interceptors.response.use((response) => response, responseInterceptorError);
    }

    private injectTokenInterceptor(config: InternalAxiosRequestConfig) {
        const token = localStorage.getItem('token');
        if (token && config.headers) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    }

    public get apiClient(): AxiosInstance {
        return this.client;
    }

    public get uploadClient(): AxiosInstance {
        return this.uploadClientInstance;
    }
}

export const httpClient = new HttpClient();
export const apiClient = httpClient.apiClient;
export const uploadClient = httpClient.uploadClient;

